module.exports = __webpack_public_path__ + "static/img/2973fa7035fb81c7577b155233b6c3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service_jgbackground.png
// module id = OuZb
// module chunks = 1